import { render, staticRenderFns } from "./exportFenxi.vue?vue&type=template&id=4fc06cf9&scoped=true"
import script from "./exportFenxi.vue?vue&type=script&lang=js"
export * from "./exportFenxi.vue?vue&type=script&lang=js"
import style0 from "./exportFenxi.vue?vue&type=style&index=0&id=4fc06cf9&prod&scoped=true&lang=css"
import style1 from "./exportFenxi.vue?vue&type=style&index=1&id=4fc06cf9&prod&lang=css"
import style2 from "./exportFenxi.vue?vue&type=style&index=2&id=4fc06cf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc06cf9",
  null
  
)

export default component.exports